<mat-card>
  <h2 translate>basicContactData.title</h2>
  <form [formGroup]="requestBasicContactForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>basicContactData.name</mat-label>
          <input
            id="nameBasicContact"
            #nameBasicContact
            matInput
            formControlName="name"
            autocomplete="off"
            (blur)="checkNameAndSurname($event, nameBasicContact)"
          />
          <mat-error *ngIf="requestBasicContactForm.controls.name.hasError('required')" translate
            >field.required</mat-error
          >
          <mat-error *ngIf="requestBasicContactForm.controls.name.hasError('incorrect')" translate
            >request.error.nameEspecialCharacter</mat-error
          >
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>basicContactData.middleName</mat-label>
          <input
            id="middleNameBasicContact"
            #middleNameBasicContact
            matInput
            formControlName="middleName"
            autocomplete="off"
            (blur)="checkNameAndSurname($event, middleNameBasicContact)"
          />
          <mat-error *ngIf="requestBasicContactForm.controls.middleName.hasError('required')" translate
            >field.required</mat-error
          >
          <mat-error *ngIf="requestBasicContactForm.controls.middleName.hasError('incorrect')" translate
            >request.error.surnameEspecialCharacter</mat-error
          >
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>basicContactData.surname</mat-label>
          <input
            id="surnameBasicContact"
            #surnameBasicContact
            matInput
            formControlName="surname"
            autocomplete="off"
            (blur)="checkNameAndSurname($event, surnameBasicContact)"
          />
          <mat-hint *ngIf="!requestBasicContactForm.controls.surname.hasError('incorrect') && optionalSurname" translate
            >request.optional</mat-hint
          >
          <mat-error *ngIf="requestBasicContactForm.controls.surname.hasError('incorrect')" translate
            >request.error.surnameEspecialCharacter</mat-error
          >
          <mat-error *ngIf="requestBasicContactForm.controls.surname.hasError('required')" translate
            >field.required</mat-error
          >
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>basicContactData.nif</mat-label>
          <input
            id="nifBasicContact"
            matInput
            formControlName="nif"
            autocomplete="off"
            maxlength="9"
            (blur)="isNif($event.target.value)"
          />
          <mat-error *ngIf="requestBasicContactForm.controls.nif.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error *ngIf="requestBasicContactForm.controls.nif.hasError('dniInvalid')" translate>
            field.error.nif
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="40" fxFlex.gt-sm="25">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>basicContactData.telephone</mat-label>
          <input
            id="telephoneBasicContact"
            matInput
            formControlName="telephone"
            maxlength="9"
            autocomplete="off"
            (blur)="updateValuePhone(true)"
          />
          <mat-error *ngIf="requestBasicContactForm.controls.telephone.hasError('required') && !optionalPhone" translate
            >field.required</mat-error
          >
          <mat-error *ngIf="requestBasicContactForm.controls.telephone.hasError('telephoneInvalid')" translate>
            field.error.telefono
          </mat-error>
          <mat-hint *ngIf="optionalPhone" translate>request.optional</mat-hint>
        </mat-form-field>
      </div>
      <div fxFlex="60" fxFlex.gt-sm="50">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>basicContactData.email</mat-label>
          <input
            id="emailBasicContact"
            matInput
            formControlName="email"
            autocomplete="off"
            (blur)="updateValueEmail(true)"
          />
          <mat-error *ngIf="requestBasicContactForm.controls.email.hasError('required') && !optionalEmail" translate
            >field.required</mat-error
          >
          <mat-hint *ngIf="optionalEmail" translate>request.optional</mat-hint>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <div fxFlex="100" class="request__button-calculate">
          <div class="request__button-submit">
            <button
              id="sendButtonBasicContact"
              color="primary"
              fxFlex="100"
              mat-flat-button
              [disabled]="disabledButtonBasicContact || this.mode === 'view'"
              (click)="sendRequestToClient()"
            >
              <mat-label translate>basicContactData.button</mat-label>
              <mat-icon class="icon-ic_send"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-card>
